export default __webpack_public_path__ + "static/media/244087189_592638525096104_656116708744791639_n (1).1a1aab69.jpg";